import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useGetOnBaseDocuments from '../hooks/useGetOnBaseDocuments';
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';

function ViewOnBaseDocumentModal(paramvalues: { handleClose: any, RowKey: string }) {

    let getdocparams: GetOnBaseDocumentsRequest = {
        rowKey: paramvalues.RowKey,
        partitionKey: "ToOnBase",
        MaxRetries: 5,
        OnBaseReceived: false,
        IsDeleted: false
    }

    const { Data, loading } = useGetOnBaseDocuments(getdocparams, 0);

    const footerContent = (
        <div>
            <Button 
                label="Close" 
                icon="pi pi-times" 
                onClick={() => paramvalues.handleClose()} 
                className="p-button-primary"
            />
        </div>
    );

    return (
        <>
            <Dialog 
                header="Document Details" 
                visible={true} 
                style={{ width: '50vw' }} 
                onHide={() => paramvalues.handleClose()}
                footer={footerContent}
            >
                <div className="p-fluid">
                    <div className="field grid">
                        <label htmlFor="partitionKey" className="col-12 mb-2 md:col-2 md:mb-0">
                            PartitionKey
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="partitionKey" 
                                value={Data.map(item => item.partitionKey).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="rowKey" className="col-12 mb-2 md:col-2 md:mb-0">
                            RowKey
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="rowKey" 
                                value={paramvalues.RowKey} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="eTag" className="col-12 mb-2 md:col-2 md:mb-0">
                            eTag
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="eTag" 
                                value={Data.map(item => item.eTag).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="document" className="col-12 mb-2 md:col-2 md:mb-0">
                            Document
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="document" 
                                value={Data.map(item => item.documentName).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="type" className="col-12 mb-2 md:col-2 md:mb-0">
                            Type
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="type" 
                                value={Data.map(item => item.onBaseDocumentTypeName).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="altId" className="col-12 mb-2 md:col-2 md:mb-0">
                            Alt Id
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="altId" 
                                value={Data.map(item => JSON.stringify(item.benesysAltId)).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="firstName" className="col-12 mb-2 md:col-2 md:mb-0">
                            First Name
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="firstName" 
                                value={Data.map(item => item.firstName).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="lastName" className="col-12 mb-2 md:col-2 md:mb-0">
                            Last Name
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="lastName" 
                                value={Data.map(item => item.lastName).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="client" className="col-12 mb-2 md:col-2 md:mb-0">
                            Client
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="client" 
                                value={Data.map(item => item.client).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="clientLocation" className="col-12 mb-2 md:col-2 md:mb-0">
                            Client Location
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="clientLocation" 
                                value={Data.map(item => item.clientLocation).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="notes" className="col-12 mb-2 md:col-2 md:mb-0">
                            Notes
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="notes" 
                                value={Data.map(item => item.notes).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="attempts" className="col-12 mb-2 md:col-2 md:mb-0">
                            Attempts
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="attempts" 
                                value={Data.map(item => JSON.stringify(item.onBaseAttemptNumber)).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="received" className="col-12 mb-2 md:col-2 md:mb-0">
                            Received
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="received" 
                                value={Data.map(item => JSON.stringify(item.onBaseReceived)).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="notification" className="col-12 mb-2 md:col-2 md:mb-0">
                            Notification
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="notification" 
                                value={Data.map(item => JSON.stringify(item.supportNotificationSent)).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>

                    <div className="field grid">
                        <label htmlFor="time" className="col-12 mb-2 md:col-2 md:mb-0">
                            Time
                        </label>
                        <div className="col-12 md:col-10">
                            <InputText 
                                id="time" 
                                value={Data.map(item => JSON.stringify(item.timestamp)).join(', ')} 
                                readOnly 
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default ViewOnBaseDocumentModal;